<template>
  <div class="container">
    <div class="split-line"></div>
  </div>
</template>

<script>
export default {
  name: 'AppFoot'
}
</script>

<style scoped>
/* @import ''; */
.container {
  width: 100%;
  height: 150px;
  position: relative;
}
.split-line {
  position: absolute;
  top: 30px;
  width: 100%;
  border-top: 1px solid rgb(0, 37, 60);
  box-shadow: 0px 0px 1px rgb(0, 37, 60);
}
</style>
